/** @jsxImportSource @emotion/react */
import type { css } from '@emotion/react'

import type { BlocksDownloadComponent } from '@twisto/api-cms'
import { useBreakpoint } from '@twisto/hooks'

import { StoreButton, StrapiMedia } from '../../atoms'

import * as widgetStyles from './download-widget.styles'

type DownloadWidgetProps = {
  styles?: ReturnType<typeof css>
}

export const DownloadWidget = ({
  headline,
  src,
  stores,
  styles,
}: BlocksDownloadComponent & DownloadWidgetProps) => {
  const isDesktop = useBreakpoint('smMdUp')

  return (
    <div css={[widgetStyles.download, styles]}>
      {isDesktop && (
        <>
          <StrapiMedia {...src} css={widgetStyles.qrCode} />
          <h4 css={widgetStyles.headline}>{headline}</h4>
        </>
      )}
      <div css={widgetStyles.stores}>
        {stores?.map(({ id, storeLogo, url }) => (
          <StoreButton key={id} storeLogo={storeLogo} url={url} />
        ))}
      </div>
    </div>
  )
}
